<div class="w-100-p">
    <mat-checkbox name="to.name"
    [formControl]="formControl"
    [formlyAttributes]="field">
        {{to.label}}
    </mat-checkbox>
</div>